/* eslint-disable @typescript-eslint/naming-convention */
import { Effect, Reducer } from '@umijs/max';
import { TramitType } from '@/interfaces/files';
import { getInbox, getInboxes, getTramitTypes, getTransferTypes } from '@/services/files.service';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface ModelType {
  namespace: string;
  state: {
    tramitsTypes: TramitType[];
    zones: TramitType[];
    loadingPKI: boolean;
    allZones: TramitType[];
    isFetchingInboxes: boolean;
  };
  effects: {
    fetchData: Effect;
    fetchTramitTypes: Effect;
    fetchMyZones: Effect;
  };
  reducers: {
    setData: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'inboxDetail',

  state: {
    zones: [],
    allZones: [],
    tramitsTypes: [],
    loadingPKI: false,
    isFetchingInboxes: false,
  },

  effects: {
    *fetchData({ payload }, { call, put, all }) {
      try {
        yield put({
          type: 'setData',
          payload: { loadingPKI: true },
        });
  
        const [inbox] = yield all([call(getInbox, payload)]);
        yield put({
          type: 'setData',
          payload: { inbox: inbox.data },
        });
  
        yield put({
          type: 'setData',
          payload: { loadingPKI: false },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *fetchTramitTypes({ payload }, { call, put, all }) {
      const [tramitsTypes, zones] = yield all([
        call(getTramitTypes, payload),
        call(getTransferTypes, payload),
      ]);

      yield put({
        type: 'setData',
        payload: {
          tramitsTypes: tramitsTypes.data,
          allZones: zones.data,
          zones: zones.data.filter((a: any) => a.enabled && a.name !== 'Web'),
        },
      });
    },

    *fetchMyZones({ payload }, { call, put, all }) {
      yield put({
        type: 'setData',
        payload: {
          isFetchingInboxes: true,
        },
      });
      const [myzones] = yield all([call(getInboxes, payload)]);

      yield put({
        type: 'setData',
        payload: {
          myzones: myzones.data.results,
          isFetchingInboxes: false,
        },
      });
    },
  },

  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
